export default "__VITE_ASSET__DBwtNsZH__"